import clsx from "clsx";
import { PlanNameChip } from "../../PlanNameChip";
import type { PlanNameListProps } from "./types";

export const PlanNameList = ({
  floorPlanIds,
  planNameById,
  className,
}: PlanNameListProps) => (
  <div
    className={clsx(
      "flex w-full min-w-0 flex-col items-start gap-1",
      className,
    )}
  >
    {floorPlanIds.map((floorPlanId) => (
      <PlanNameChip
        key={floorPlanId}
        name={planNameById.get(floorPlanId) ?? ""}
        variant="outlined"
      />
    ))}
  </div>
);
